import React from 'react';
import Hero from "../components/Hero";
import Header from "../components/Header";
import TextBox from '../components/LinkBox';
import BackgroundBox from '../components/BackgroundBox';
import { Box, Typography, Grid } from '@mui/material';
import { createGlobalStyle } from 'styled-components';
import House from '../assets/house.jpg';
import Aviao from '../assets/avião.jpg';
import Moto from '../assets/moto.png';
import Family from '../assets/familia.jpg';
import Key from '../assets/chave.jpg';
import Plano from '../assets/cadeado.png';
import BlueCar from "../assets/carro_azul.png";
import Cotacao from '../components/Cotacao';
import Footer from '../components/Footer';

const GlobalStyle = createGlobalStyle`
  body, html {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%; 
    overflow-x: hidden;
    overflow-y: auto;
  }
`;

function Home() {
  return (
    <div style={{ backgroundColor: '#f0f0f0', minHeight: '100vh', position: 'relative' }}>
      <GlobalStyle />
      <Header />
      <Hero />

   

      <Box sx={{ padding: '20px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextBox 
              color="#ffffff"
              width="100%"
              height="200px"
              title="AMPLO SERVIÇO"
              titleColor="#103874"
              text="Garantimos a segurança do seu patrimônio, seja ele automóvel (carro, moto, van, caminhão), residência, vida, fiança locatícia, capitalização, consórcio."
              textColor="#454545"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextBox 
              color="#ffffff"
              width="100%"
              height="200px"
              title="PROTEÇÃO PARA TODO O BRASIL"
              titleColor="#103874"
              text="Cobertura para todo o território brasileiro e também Mercosul*."
              textColor="#454545"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextBox 
              color="#ffffff"
              width="100%"
              height="200px"
              title="ATENDIMENTO 24H"
              titleColor="#103874"
            
              
              textColor="#454545"
            />
          </Grid>
        </Grid>
      </Box>

      <Box
  sx={{
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    padding: '16px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    marginBottom: '20px',
    textAlign: 'center',
  }}
>
  <Box
    component="img"
    src={Plano}
    alt="Logo"
    sx={{
      width: { xs: '120px', sm: '180px', md: '220px', lg: '260px' },
      marginBottom: '16px',
    }}
  />
  <Typography 
    variant="h5" 
    gutterBottom 
    sx={{ color: '#103874', width: '100%' }}
  >
    Planos sob medida para você
  </Typography>
  <Typography 
    variant="body2" 
    sx={{ color: '#454545', maxWidth: '500px' }}
  >
    Planos de qualidade com as melhores seguradoras. Escolha a categoria ideal para sua necessidade.
  </Typography>
</Box>


      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={6} md={2.4} display="flex" justifyContent="center">
          <BackgroundBox 
            image={Moto} 
            overlayColor="rgba(0, 0, 0, 0.5)" 
            title="Auto"
            titleColor="#ffffff"
            titleSize="2rem"
            height="auto"
            hoverText="Proteção para seu veículo, seja ele 2, 4 ou mais rodas."
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.4} display="flex" justifyContent="center">
          <BackgroundBox 
            image={Family} 
            overlayColor="rgba(0, 0, 0, 0.5)" 
            title="Vida"
            titleColor="#ffffff"
            titleSize="2rem"
            height="auto"
            hoverText="Proteja o futuro da sua família, proporcionando segurança financeira e coberturas especiais para serem usadas em vida."
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.4} display="flex" justifyContent="center">
          <BackgroundBox 
            image={Aviao} 
            overlayColor="rgba(0, 0, 0, 0.5)" 
            title="Viagem"
            titleColor="#ffffff"
            titleSize="2rem"
            height="auto"
            hoverText="Viaje sem preocupações, nossos seguros cobrem imprevistos e emergências para que você viva experiências inesquecíveis."
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.4} display="flex" justifyContent="center">
          <BackgroundBox 
            image={Key} 
            overlayColor="rgba(0, 0, 0, 0.77)" 
            title="Fiança Locatícia /Capitalização"
            titleColor="#ffffff"
            titleSize="1.5rem"
            height="auto"
            hoverText="Facilite a locação de imóveis, garantindo segurança para locadores e locatários."
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.4} display="flex" justifyContent="center">
          <BackgroundBox 
            image={House} 
            overlayColor="rgba(0, 0, 0, 0.5)" 
            title="Residencial"
            titleColor="#ffffff"
            titleSize="2rem"
            hoverText="Segurança por danos ou perdas causadas por eventos inesperados."
          />
        </Grid>
      </Grid>

      <Box sx={{ padding: '20px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Box
              component="img"
              src={BlueCar}
              alt="Imagem de um carro"
              sx={{
                width: '90%',
                height: 'auto',
                margin: '0 auto',
                objectFit: 'cover',
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Cotacao
              serviceId="service_zky97ij" 
              templateId="template_7luh384" 
              userId="K6sXHa7DR1iJvD8GU" 
               colaborador="pelo site"/>

          </Grid>
        </Grid>
      </Box>

      <Footer />
    </div>
  );
}

export default Home;
